import { generateRandomArray } from '../../utils';
import { FontAwesomeIcon } from './AssetsHelper';


const Rating = ({ rating, className, iconClass }) => {
       return rating ? 
              <div className={`f-center ${className}`}>
                     {generateRandomArray(5).map((rate, index) => <span className={`${rate > rating? 'text-gray-300' : 'text-warning'} ${iconClass}`} key={index}>
                            <FontAwesomeIcon type={'solid'} icon={'star'}/>
                            </span>)
                     }
              </div> 
       : null
}
export default Rating
